import {adminStates} from './admin-routes';

export default function AdminService(
    $q,
    $state
) {
    'ngInject';

    Object.assign(this, {
        handle404,
    });

    function handle404(error) {
        if (error.status === 404) {
            $state.go(adminStates.ERROR_404);
        }
        return $q.reject(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-service.js